<script lang="ts">
  import { Route, Router } from "svelte-routing"

  import NFTList from "./pages/NFTList.svelte"
  import NFTDetail from "./pages/NFTDetail.svelte"
  import TopBar from "./components/TopBar.svelte"
  import Staking from "./pages/Staking.svelte"
  import Footer from "./components/Footer.svelte"
  import Upload from "./pages/Upload.svelte"
  import UploadDetail from "./pages/UploadDetail.svelte"
  import Positions from "./pages/Positions.svelte"
  import Bids from "./pages/Bids.svelte"
  import { initClient } from "@urql/svelte"
  import { chainId as walletChainId, connected, makeEvmStores } from "svelte-web3"
  import { COREABI } from "./abis/core"
  import {
    currentChainId,
    multipliers,
    tokenAddress,
    tokenPrice,
    viewCoreContract,
    viewWeb3,
  } from "./stores/store"
  import { CHAIN_NAMES, CHAINS, DENOMINATORS, USDC } from "./stores/constants"
  import { CONFIG } from "./config"
  import { GraphQLClient } from "graphql-request"
  // import { quoteTokenPrice } from "./utils/utils"

  export let url = ""

  let urlChainId = 1; // TODO
  const urlParams = new URLSearchParams(window.location.search);
  if (CHAINS.hasOwnProperty(urlParams.get('chain'))) {
    urlChainId = CHAINS[urlParams.get('chain')];
    currentChainId.set(urlChainId);
  }

  let viewStores = makeEvmStores('view');
  viewStores.setProvider(CONFIG[$currentChainId].RPC_URL);

  tokenAddress.set({
    PIL: CONFIG[$currentChainId].PIL_ADDRESS,
    USDC: CONFIG[$currentChainId].USDC_ADDRESS,
    WETH: CONFIG[$currentChainId].WETH_ADDRESS,
  })

  const getMultipliers = async () => {
    const rewardParams = {};
    let minRewardparam = Infinity;
    for (let token of DENOMINATORS) {
      const result = await $viewCoreContract.methods.getDistPoolInfo($tokenAddress[token.symbol]).call();
      const rewardParam = 1 / result[0];
      rewardParams[token.symbol] = rewardParam;
      if (rewardParam < minRewardparam) minRewardparam = rewardParam;
    }
    for (let token of DENOMINATORS) {
      $multipliers[token.symbol] = Math.round(rewardParams[token.symbol] / minRewardparam);
    }
  }

  $: if ($viewStores.connected) {
    const core = new $viewStores.web3.eth.Contract(COREABI, CONFIG[$currentChainId].CORE_ADDRESS);
    viewCoreContract.set(core);
    viewWeb3.set($viewStores.web3);

    getMultipliers();
  }

  $: if ($connected) {
    currentChainId.set($walletChainId);
  }

  currentChainId.subscribe(value => {
    if (!CONFIG.hasOwnProperty(value)) {
      urlParams.set('chain', 'mainnet');
      window.location.search = urlParams.toString();
      return;
    }
    if (CHAIN_NAMES[urlChainId] !== CHAIN_NAMES[value]) {
      urlParams.set('chain', CHAIN_NAMES[value]);
      window.location.search = urlParams.toString();
    }
    initClient({
      url: CONFIG[value].GRAPH_URL
    })
    tokenAddress.set({
      PIL: CONFIG[value].PIL_ADDRESS,
      USDC: CONFIG[value].USDC_ADDRESS,
      WETH: CONFIG[value].WETH_ADDRESS,
    })
  })

  for (let token of DENOMINATORS) {
    let fromTokenAddress = ''
    if (token.symbol === 'USDC')
      continue;
    else if (token.symbol === 'PIL')
      fromTokenAddress = CONFIG[1].PIL_ADDRESS;
    else
      fromTokenAddress = CONFIG[1].WETH_ADDRESS;
    const quoteParams = {
      fromTokenAddress: fromTokenAddress,
      toTokenAddress: CONFIG[1].USDC_ADDRESS,
      amount: (10 ** token.decimals).toString(),
    };
    const apiUrl = `https://api.1inch.io/v4.0/1/quote`;
    fetch(`${apiUrl}?${(new URLSearchParams(quoteParams)).toString()}`)
      .then(res => res.json())
      .then(res => {
        $tokenPrice[token.symbol] = Number.parseInt(res.toTokenAmount) / 10 ** USDC.decimals;
      })
  }

</script>

<div id="wrapper">
  <Router {url}>
    <TopBar />
    <div class="router">
      <Route path="nft/:id" let:params>
        <NFTDetail id={params.id} />
      </Route>
      <Route path="/" component={NFTList} />
      <Route path="/staking" component={Staking} />
      <Route path="/upload" component={Upload} />
      <Route path="/upload/:address/:id" let:params>
        <UploadDetail address={params.address} id={params.id} />
      </Route>
      <Route path="/portfolio/positions" component="{Positions}" />
      <Route path="/portfolio/bids" component="{Bids}" />
    </div>
  </Router>
</div>
<Footer/>
